import React from "react";
import { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import Loading from './Loading';
import { useLocation,useNavigate,useSearchParams,useParams } from 'react-router-dom';
import { configData } from "../config";

const ViewTestimonialPage = ({page}) => {

    const [isLoading, setIsLoading] = useState(false);
    const [detailedview, setDetailedView] = useState({});
    var {tab} = useParams();
    const app_url = configData.APP_URL;
    const {sid} = useParams();
if (!page) {
    return <Loading />;
}
   
    

    return (
        <>
            {isLoading ? (
                <Loading />
            ) : (
                <div>
                    <div className="view-agent-msg-container">
                        <div dangerouslySetInnerHTML={{ __html: page.body }} />
                    </div>
                </div>
            )}
        </>
    );
};
export default ViewTestimonialPage;